import { conditieMixin } from "@/mixins/conditieMixin";
import { magnetMixin } from "@/mixins/magnetMixin";

export const prognoseMixin = {
  mixins: [conditieMixin, magnetMixin],
  props: {
    mods: { type: Array },
    inventarisatie: {
      type: Object,
      default: function() {
        return {};
      }
    },
    bouwjaar: { 
      type: Number, 
      default: new Date().getUTCFullYear() 
    },
    onderdelen: {
      type: Array,
      default: function() {
        return [];
      }
    },
    conditieStandaarden: {
      type: Array,
      default: function() {
        return [];
      }
    },
    config: {
      type: Object,
      default: function() {
        return {
          jaren: 15,
          jaar: 2016,
          showModeratorPanel: false,
          bouwjaar: 1980,
          smalltable: true,
          modus: "Positie",
          footClone: false,
          inclusief: 0,
          maxConditie: null  // Default to 'no limit'
        };
      }
    }
  },
  computed: {
    inclusiefJaar: function() {
      return new Date().getFullYear() + (this.config.inclusief || 0);
    },
    groepen: function() {
      return [
        {
          value: 0,
          text: "Groep 1",
          tag: "aanbrengen/vervanging",
          NENconditie: "",
          standaardConditie: "ConditieVervanging",
          inclusiefGebreken: false
        },
        {
          value: 1,
          text: "Groep 2",
          tag: "revisie en gebreken",
          NENconditie: "",
          standaardConditie: "ConditieRevisie",
          inclusiefGebreken: true
        }
      ];
    },
    activeMods: function() {
      return this.mods ? this.mods.filter(m => m.active) : [];
    },
    rows() {
      return this.getRowsFrom({
        children: this.onderdelen,
        jaar: this.bouwjaar
      });
    },
    totaal() {
      var totalen = {};
      for (var r of this.rows) {
        var regelResultaat = this.getResultaatGemodereerd(r);
        for (
          var i = this.config.jaar;
          i < this.config.jaar + this.config.jaren;
          i++
        ) {
          // var sub = this.getJaar(regelResultaat, i) * this.getMultiplier(r.multiplier);
          var sub = this.getJaar(regelResultaat, i);
          !totalen[i] ? (totalen[i] = sub) : (totalen[i] += sub);
        }
      }
      return totalen;
    }
  },
  methods: {
    getPrognoseResultaat(rijen) {
      var vm = this;
      return {
        // start
        start: vm.config.jaar,
        // eind
        eind: vm.config.jaar + vm.config.jaren,
        totalen: vm.totaal,
        groepen: vm.groepen,
        rijen: rijen.map(function(item) {
          var rijresultaat = vm.getResultaatGemodereerd(item);

          return {
            titel: item.title,
            level: item.level,
            element: item.isElement || false,
            start: item.jaar || item.basejaar,
            // id: item.elementId,
            onderdeel: item,
            foto: item.foto,
            multiplier: vm.getMultiplier(item.multiplier),

            // controle resultaat
            resultaat: rijresultaat,

            // gegroepeerd resultaat
            groepen: vm.groepen.map(function(groep) {
              //return vm.getGroepResultaat(item, groep);
              return vm.getGroepResultaat2(rijresultaat, groep);
            }),

            notitie: item.notitie || "geen",

            acties: rijresultaat.acties,

            gebreken: item.gebreken.map(function(gebrek) {
              return {
                gebrek: gebrek,
                conditie: vm.getConditieGebrek(gebrek)
              };
            })
          };
        })
      };
    },

    getGroepResultaat2(resultaat, g) {
      var selectie =
        resultaat.acties.filter(a => a.actie.groep == g.value) || [];
      var condities = [-1];
      var conditiesActies = [-1];
      var conditiesGebreken = [-1];
      

      // Collect action conditions (will be limited)
      for (var h of selectie || []) {
        conditiesActies.push(h.conditie.conditie);
      }

      // Apply limit to action conditions only
      var slechtsteActieConditie = Math.max(...conditiesActies);
      var effectieveActieConditie = this.applyConditieLimit(slechtsteActieConditie, resultaat.onderdeel || {});
      
      
      condities.push(effectieveActieConditie);

      if (g.inclusiefGebreken) {
        selectie = selectie.concat(resultaat.gebreken);
        for (var gebrek of resultaat.gebreken) {
          conditiesGebreken.push(this.getConditieGebrek(gebrek));
        }
        // Gebreken are not limited (by design)
        var slechtsteGebrekConditie = Math.max(...conditiesGebreken);
        condities.push(slechtsteGebrekConditie);
      }

      return {
        resultaat: selectie,
        groep: g.value,
        conditie: Math.max(...condities)
      };
    },

    getRowsFrom(prognose) {
      var vm = this;
      var r = [];
      var level = 0;

      function recurse(rows, parent, level) {
        for (var n in parent.children) {
          var child = parent.children[n];

          vm.createOnderdeel(child, parent, level, n);

          r.push(child);

          if (child.children && child.children.length > 0)
            recurse(rows, child, level + 1);
        }
      }

      // start van bouwen van rijen
      recurse(r, prognose, level);

      return r;
    },

    createOnderdeel(child, parent, level, n) {
      var vm = this;
      if (!child.gebreken) vm.$set(child, "gebreken", []);
      if (!child.acties) vm.$set(child, "acties", []);
      child.index = n;
      child.level = level;
      child.basejaar = parent.jaar || parent.basejaar;
      child.repeater = {
        start: child.jaar || parent.jaar || parent.basejaar,
        cyclus: child.cyclus,
        eind: child.eind
      };

      child.onPasteSibling = function(item) {
        parent.children.push(item);
        vm.clipboard = null;
      };

      child.onPasteChild = function(item) {
        if (!child.children) vm.$set(child, "children", []);
        child.children.push(item);
        vm.clipboard = null;
      };

      child.onCut = function(index) {
        return parent.children.splice(index, 1)[0];
      };

      child.onCopy = function(item) {
        var child = {
          title: "Kopie van " + item.title,
          jaar: item.jaar
        };
        return vm.createOnderdeel(child, item.parent, -1, -1);
      };

      child.move = function(oldPos, newPos) {
        //parent.children
        if (newPos >= parent.children.length) {
          var k = newPos - parent.children.length + 1;
          while (k--) {
            parent.children.push(undefined);
          }
        }
        parent.children.splice(newPos, 0, parent.children.splice(oldPos, 1)[0]);
      };

      child.canMoveDown = function(index) {
        return parent.children.length - 1 == index;
      };

      child.parent = {
        jaar: parent.jaar,
        conditie: level > 0 ? this.getSlechtsteConditie(parent) : -1
      };
      child._cellVariant = "table-gray-800"
      return child;
    },
    getJaar(resultaat, jaar) {
      var acties = resultaat.acties.filter(a => a.jaren.includes(jaar));
      var gebreken = resultaat.gebreken.filter(g => g.planning == jaar);
      var totaalacties = acties.reduce(
        (a, b) =>
          a +
          (( b.startjaar == jaar) ? (b.actie.startbedrag || 0) : (b.actie.bedrag)),
        0
      );
      var totaalgebreken = gebreken.reduce((a, b) => a + b.bedrag, 0);
      return Math.round(Number(totaalacties * resultaat.multiplier) + Number(totaalgebreken));
    },

    indexPrognose() {
      var factor = prompt('index','1');
      this.indexeerPrognoseBy(factor);
    },

    indexeerPrognoseBy(factor, jaar) {
      for (var r of this.rows) {
        for (var a of r.acties) {
          a.bedrag = a.bedrag * factor;
          a.startbedrag = a.startbedrag * factor;
        }
        for (var g of r.gebreken) {
          g.bedrag = g.bedrag * factor;
        }
      }
      this.inspectie.inspectie.config.prijspeil = jaar;
    },

    getResultaatGemodereerd(onderdeel) {
      var vm = this;
      var actieresultaten = onderdeel.acties.map(a =>
        vm.getResultaatActie(a, onderdeel.jaar || onderdeel.basejaar)
      );

      // acties met operator
      actieresultaten
        .filter(a => a.operator)
        .forEach(function(uitkomst, index, arr) {
          uitkomst.jaren = vm["Operator" + uitkomst.operator](
            uitkomst.jaren,
            index > 0 ? arr[index - 1].jaren : []
          );
          uitkomst.planjaren = vm["Operator" + uitkomst.operator](
            uitkomst.planjaren,
            index > 0 ? arr[index - 1].planjaren : []
          );

          uitkomst.planjaar= Math.min.apply(Math, uitkomst.planjaren)
        });

      var gebreken = onderdeel.gebreken.filter(
        //g => g.jaar != null && !g.uitgevoerd
        g => g.jaar != null 
      ); // alleen geplande gebreken

      gebreken.forEach(function(t) {
        t.planning = t.stuck
          ? t.jaar
          : Number(t.jaar) + Number(vm.getOffset(t.jaar));
      }); // alleen geplande gebreken

      return {
        acties: actieresultaten,
        gebreken: gebreken,
        multiplier: this.getMultiplier(onderdeel.multiplier),
        onderdeel: onderdeel // Add reference to onderdeel for conditie limit
        // TODO: verwijderen van de multiplier op gebreken.
      };
    },

    getResultaatActie(actie, startjaar) {
      var eerstejaar = actie.jaar || startjaar;
      var jaren = [eerstejaar].concat(
        actie.jaren.map(herhaling => herhaling.jaar)
      );

      jaren = jaren.concat(
        this.getAanvullendejaren(
          Math.max(...jaren, eerstejaar), // van het laatstejaar starten
          actie.einde ? actie.einde : this.config.jaar + this.config.jaren, // eind
          actie.cyclus,
          actie.stuck
        )
      );

      var planjaren = actie.jaren
        .filter(j => !j.uitgevoerd)
        .map(j => j.jaar);

      planjaren = planjaren.concat(
        this.getAanvullendejaren(
          Math.max(...planjaren.concat(eerstejaar)),
          actie.einde ? actie.einde : (this.config.jaar + this.config.jaren), // eind
          actie.cyclus,
          actie.stuck
        )
      ).filter((j) => j > this.inclusiefJaar);

     return {
        actie: actie,
        startjaar: eerstejaar,
        jaren: jaren,
        oplevering: [...jaren],
        planjaren: planjaren,
        planjaar: Math.min.apply(Math, planjaren),
        conditie: this.huidigeConditieOpBasisVanUitvoering(actie, startjaar),
        groep: actie.groep,
        operator: actie.operator
      };
    },

    getAanvullendejaren(start, tot, cyclus, metoffset) {
      // haalt jaren op tot..
      var js = [start];
      while (start < tot) {
        start += Math.max(1, cyclus);
        js.push(metoffset ? start : this.getOffset(start) + start);
      }
      return js;
    },

    OperatorA(arr1, arr2) {
      // ALTIJD
      return arr1;
    },

    OperatorB(arr1, arr2) {
      // ALLEEN ALS 0
      return arr1.filter(j => !arr2.includes(j));
    },

    huidigeConditieOpBasisVanUitvoering(actie, startjaar) {
      //var jaren = this.actieJaren(actie, startjaar);
      var huidigjaar = this.inclusiefJaar;
      var laatsteJaar = Math.max.apply(
        Math,
        actie.jaren
          .filter(j => j.jaar <= huidigjaar && j.uitgevoerd)
          .map(j => j.jaar)
          .concat([actie.jaar || startjaar])
      );
      return {
        conditie: this.getConditie(huidigjaar - laatsteJaar, actie.levensduur),
        laatste: laatsteJaar,
        leeftijd: huidigjaar - laatsteJaar
      };
    },

    planJaar(actie, startjaar) {
      //var jaren = this.actieJaren(actie, startjaar);
      var huidigjaar = this.inclusiefJaar;
      var planjaar = Math.min.apply(
        Math,
        actie.jaren
          .filter(j => j.jaar >= huidigjaar && !j.uitgevoerd)
          .map(j => j.jaar)
      );
      return planjaar;
    },

    // getSlechtsteConditie(item) {
    //   var condities = [-1]; // standaard conditie op basis van veroudering.

    //   for (var h of item.acties || [])
    //     condities.push(
    //       this.huidigeConditieOpBasisVanUitvoering(
    //         h,
    //         item.jaar || item.basejaar
    //       ).conditie
    //     );
    //   for (var g of item.gebreken.filter(g => !g.uitgevoerd))
    //     condities.push(this.getConditieGebrek(g));

    //   return Math.max(...condities);
    // },
    getSlechtsteConditie(item) {
      var conditiesActies = [-1]; // conditions from acties only
      var conditiesGebreken = [-1]; // conditions from gebreken only
    
      // Collect conditions from acties
      for (var h of item.acties || []) {
        conditiesActies.push(
          this.huidigeConditieOpBasisVanUitvoering(
            h,
            item.jaar || item.basejaar
          ).conditie
        );
      }
    
      // Collect conditions from gebreken (no limit applied)
      for (var g of item.gebreken.filter(g => !g.uitgevoerd)) {
        conditiesGebreken.push(this.getConditieGebrek(g));
      }
    
      var slechtsteActieConditie = Math.max(...conditiesActies);
      var slechtsteGebrekConditie = Math.max(...conditiesGebreken);
    
      // Apply limit to acties only
      var effectieveActieConditie = this.applyConditieLimit(slechtsteActieConditie, item);
    
      // Return worst of limited acties and unlimited gebreken
      return Math.max(effectieveActieConditie, slechtsteGebrekConditie);
    },
    
    applyConditieLimit(conditie, item) {
      // Check for onderdeel-specific limit first, then global config
      var limit = item.maxConditie || 
                  (this.config && this.config.maxConditie) ||
                  (this.inspectie && this.inspectie.inspectie && this.inspectie.inspectie.config && this.inspectie.inspectie.config.maxConditie);
      
      if (limit && conditie > limit) {
        return limit;
      }
      
      return conditie;
    },

    getMultiplier(expression) {
      var e = this.inventarisatie;
      return Number(eval(expression)) || 1;
    },

    getOffset(jaar) {
      var offset = 0;
      for (var mod of this.activeMods) {
        offset = this.strength(mod, jaar);
      }
      return offset;
    }
  }
};
